import { render, staticRenderFns } from "./chooseRecord.vue?vue&type=template&id=26968dbe&"
import script from "./chooseRecord.vue?vue&type=script&lang=js&"
export * from "./chooseRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports